import { request, superveneApi } from '@/plugins/plugin-request'

export function getMenuList(params) {
  return request
    .get({
      url: 'common.getMenuListV1',
      params: {
        ...params,
      },
    })
    .then(res => res.data)
}
export function postUserSystemSetting(params) {
  return request
    .post({
      url: 'common.setUserSystemSetting',
      params: {
        ...params,
      },
    })
    .then(res => res.data)
}

export function getMenuListForUser(params) {
  return request
    .get({
      url: 'common.getMenuListForUser',
      params,
    })
    .then(res => res.data)
}
export const getMenuListForAll = superveneApi(params => {
  return request
    .get({
      url: 'common.getMenuListForAll',
      params,
    })
    .then(res => res.data)
})
